import tuner from '@tunein/web-tuner';
import assetUrl from '../../utils/assetUrl';

export default function setupTuner(
  webApiClientInstance,
  playerElement,
  tunerConfigs,
) {
  tuner.setup({
    playerElement,
    blankMp3Url: assetUrl('assets/media/blank.mp3'),
    tuneInApiClient: webApiClientInstance,
    ...tunerConfigs,
  });

  return tuner;
}
